import React, { lazy, memo, Suspense, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import MobileLayout from '../../components/MobileLayout'
import Questions from '../../components/organisms/Questionnaire/Questions'
import KidneyScoreBridge from '../../components/organisms/KidneyScoreBridge'
import { authenticateUserRequest, setAllQuestions } from '../../redux/slices'
import LoginBottomSheet from '../../components/molecules/LoginBottomSheet'
import { trackEventCKD } from '../../analytics'
import { EVENTS } from '../../analytics/events'
import useLeadId from '../../hooks/useLead'
import TrackingPixel from '../../components/atoms/TrackingPixel'
import sendEventData from '../../utils/helpers/sendMail'

const Loader = lazy(() => import('../../components/atoms/Loader'))

const Questionnaire = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const loginSheetRef = useRef(null)

  const { questions } = useSelector((state) => state.questionnaire)
  const { userDetails } = useSelector((state) => state.auth)

  const leadId = useLeadId()

  const queryParams = new URLSearchParams(location.search)
  const [comingFromButton, setComingFromButton] = useState(
    queryParams.get('fromButtonPress') ?? 'false',
  )
  const from = queryParams.get('from')
  const phoneNumber = queryParams.get('phoneNumber') ?? null

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (comingFromButton === 'false') return
    if (!!phoneNumber && from === 'SCORED') {
      dispatch(
        authenticateUserRequest({
          contact_no: Number(phoneNumber),
          patient_meta_info: {
            support_program_type: 'Life Ka Filter',
          },
        }),
      )
    } else if (!userDetails.data) {
      document.activeElement?.blur()
      loginSheetRef.current?.show()
    }
  }, [comingFromButton])

  useEffect(() => {
    if (from === 'SCORED') {
      console.log(
        'trackEventCKD --> CKD_LKF_Kidney_Score_Questionnaire_Landing',
      )
      trackEventCKD(EVENTS.CKD_LKF_Kidney_Score_Questionnaire_Landing)
    }
  }, [from])

  // useEffect(() => {
  //   if (from === 'SCORED' && leadId && userDetails?.data?.contact_no) {
  //     sendEventData({
  //       lead_id: leadId,
  //       phone_no: userDetails?.data?.contact_no,
  //       page: 'kidney-score',
  //     })
  //   }
  // }, [leadId, userDetails])

  useEffect(() => {
    if (!dispatch) return

    const filterAndMergeQuestions = (type) => {
      const finalQuestion = questions.map((q) => {
        if (q.type.includes(type)) {
          return {
            ...q,
            isHide: false,
          }
        } else {
          return {
            ...q,
            isHide: true,
          }
        }
      })
      return finalQuestion
    }

    const questionType = from === 'SCORED' ? 'SCORED' : 'PNDS'
    const finalQuestions = filterAndMergeQuestions(questionType)

    dispatch(setAllQuestions(finalQuestions))

    const timer = setTimeout(() => setLoading(false), 300)

    return () => clearTimeout(timer)
  }, [dispatch, from])

  return (
    <MobileLayout>
      {/* {leadId && from === 'SCORED' && <TrackingPixel leadId={leadId} />} */}
      {comingFromButton === 'false' && from === 'SCORED' ? (
        <KidneyScoreBridge
          onClick={() => {
            setComingFromButton('true')
          }}
        />
      ) : (
        <>
          {loading ? (
            <Suspense fallback={<div>Loading questions...</div>}>
              <Loader title={'Loading questions...'} />
            </Suspense>
          ) : (
            <Questions from={from === 'SCORED' ? 'SCORED' : 'PNDS'} />
          )}
        </>
      )}
      <LoginBottomSheet
        ref={loginSheetRef}
        buttonTitle={'Proceed'}
        sheetHeader={'Enter mobile number to get your kidney score'}
        onLoginSuccess={(userDetails, hasSentOTP) => {
          if (hasSentOTP) {
            sendEventData({
              lead_id: leadId,
              phone_no: userDetails?.data?.contact_no,
              page: 'kidney-score',
            })
          }
        }}
        from={'result'}
      />
    </MobileLayout>
  )
}

export default memo(Questionnaire)
